import type { AncestryDefinition, CharacterOptions } from '../../shared/game/character-build.js';

/** Core Rules p. 24. */
export const goblin: AncestryDefinition = {
  id: 'goblin', name: 'Goblin', size: 'small', trait: 'Skedaddle', skedaddle: true, skillBonus: 0, initiativeBonus: 0,
  description: 'Green, cunning, and perpetually vilified, Goblins thrive on the edge of chaos. For a Goblin, vanishing into the shadows is not just a skill—it’s an identity. After all, what kind of Goblin would you be if you couldn’t slip away unnoticed?',
  traitDescription: 'Can move 2 spaces for free after you become the target of an attack or negative effect (after damage, ignoring Difficult Terrain).',
  languages: [{ id: 'goblin', name: 'Goblin', minimumIntelligence: 0 }],
  languageDescription: 'You know Goblin if your INT isn’t negative.',
  skinColors: [0x71944c, 0x567b3e, 0x8aa45b, 0x426735, 0x9aaf68, 0x3a5831],
};
export const goblinBodies: CharacterOptions['bodies'] = [
  { id: 'goblin-male', name: 'Masculine', height: [1, 1.3], ancestryId: 'goblin' },
  { id: 'goblin-female', name: 'Feminine', height: [.95, 1.25], ancestryId: 'goblin' },
];
